import { render, staticRenderFns } from "./erziyuansdcm.vue?vue&type=template&id=3cfa8700&"
import script from "./erziyuansdcm.vue?vue&type=script&lang=js&"
export * from "./erziyuansdcm.vue?vue&type=script&lang=js&"
import style0 from "./erziyuansdcm.vue?vue&type=style&index=0&id=3cfa8700&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports